import { createAction } from '@reduxjs/toolkit';

export const headerUpdateId = createAction('header/updateId');
export const headerUpdateIsAdded = createAction('header/updateIsAdded');
export const headerUpdateIsActive = createAction('header/updateIsActive');

export const headerStore = createAction('header/store');
export const headerClear = createAction('header/clear');

export const headerUpdateRequest = createAction('header/updateRequest');
export const headerUpdateError = createAction('header/updateError');
export const headerUpdateStore = createAction('header/updateStore');

export const headerUpdateName = createAction('header/updateName');
export const headerUpdateNameImage = createAction('header/updateNameImage');
export const headerUpdateNameSize = createAction('header/updateNameSize');
export const headerUpdateNameBold = createAction('header/updateNameBold');

export const headerUpdateAvatar = createAction('header/updateAvatar');
export const headerUpdateAvatarShape = createAction('header/updateAvatarShape');
export const headerUpdateAvatarBorder = createAction('header/updateAvatarBorder');
export const headerUpdateAvatarBorderColor = createAction('header/updateAvatarBorderColor');
export const headerUpdateAvatarSize = createAction('header/updateAvatarSize');
export const headerUpdateAvatarShadow = createAction('header/updateAvatarShadow');
export const headerUpdateAvatarShadowColor = createAction('header/updateAvatarShadowColor');
export const headerUpdateAvatarGradient = createAction('header/updateAvatarGradient');
export const headerUpdateIsDisplayProfilePic = createAction('header/updateIsDisplayProfilePic');
export const headerUpdateCutoutUrl = createAction('header/updateCutoutUrl');

export const headerUpdateTitle = createAction('header/updateTitle');
export const headerUpdateShortBio = createAction('header/updateShortBio');
export const headerUpdateShortBioSize = createAction('header/updateShortBioSize');
export const headerUpdateTextColor = createAction('header/updateTextColor');
export const headerUpdatePageUrl = createAction('header/updatePageUrl');
export const headerUpdateIsVerified = createAction('header/updateIsVerified');

export const headerUpdateLayout = createAction('header/updateLayout');
export const headerUpdateViewType = createAction('header/updateViewType');

export const headerUpdateActionType = createAction('header/updateActionType');
export const headerUpdateCTAPosition = createAction('header/updateCTAPosition');
export const headerUpdateCTASite = createAction('header/updateCTASite');
export const headerUpdateCTASiteText = createAction('header/updateCTASiteText');
export const headerUpdateCTABackgroundColor = createAction('header/updateCTABackgroundColor');
export const headerUpdateCTATextColor = createAction('header/updateCTATextColor');
export const headerUpdateCTAIsBorder = createAction('header/updateCTAIsBorder');
export const headerUpdateCTAOpacity = createAction('header/updateCTAOpacity');
export const headerUpdateCTALinkId = createAction('header/updateCTALinkId');
export const headerUpdateCTAButtonIcon = createAction('header/updateCTAButtonPosition');
export const headerUpdateCTABorder = createAction('header/updateCTABorder');
export const headerUpdateCTABorderColor = createAction('header/updateCTABorderColor');
export const headerUpdateCTAShadow = createAction('header/updateCTAShadow');
export const headerUpdateCTAShadowColor = createAction('header/updateCTAShadowColor');
export const headerUpdateCTAShape = createAction('header/updateCTAShape');

export const headerUpdateCover = createAction('header/updateCover');
export const headerUpdateCoverPosition = createAction('header/updateCoverPosition');
export const headerUpdateCoverHeight = createAction('header/updateCoverHeight');
export const headerUpdateCoverType = createAction('header/updateCoverType');
export const headerUpdateCoverVideo = createAction('header/updateCoverVideo');
export const headerUpdateCoverDarkness = createAction('header/updateCoverDarkness');
export const headerUpdateCoverIsText = createAction('header/updateCoverIsText');
export const headerUpdateCoverTitle = createAction('header/updateCoverTitle');
export const headerUpdateCoverTextColor = createAction('header/updateCoverTextColor');
export const headerUpdateCoverDescription = createAction('header/updateCoverDescription');
export const headerUpdateCoverCTAMargin = createAction('header/updateCoverCTAMargin');
export const headerUpdateCoverCTABorder = createAction('header/updateCoverCTABorder');
export const headerUpdateCoverCTABorderColor = createAction('header/updateCoverCTABorderColor');
export const headerUpdateCoverCTAShape = createAction('header/updateCoverCTAShape');
export const headerUpdateCoverCTAShadow = createAction('header/updateCoverCTAShadow');
export const headerUpdateCoverCTAShadowColor = createAction('header/updateCoverCTAShadowColor');

export const headerUpdateCoverActionType = createAction('header/updateCoverActionType');
export const headerUpdateCoverCTASite = createAction('header/updateCoverCTASite');
export const headerUpdateCoverCTASiteText = createAction('header/updateCoverCTASiteText');
export const headerUpdateCoverCTABackgroundColor = createAction('header/updateCoverCTABackgroundColor');
export const headerUpdateCoverCTATextColor = createAction('header/updateCoverCTATextColor');
export const headerUpdateCoverCTAIsBorder = createAction('header/updateCoverCTAIsBorder');
export const headerUpdateCoverCTAOpacity = createAction('header/updateCoverCTAOpacity');
export const headerUpdateCoverCTALinkId = createAction('header/updateCoverCTALinkId');
// export const headerUpdateCoverCTAPosition = createAction('header/updateCoverCTAPosition');
export const headerUpdateCoverTextPosition = createAction('header/updateCoverTextPosition');
export const headerUpdateCoverButtonPosition = createAction('header/updateCoverButtonPosition');

export const headerUpdateSocialLinksAlign = createAction('header/updateSocialLinksAlign');
export const headerUpdateSocialIconStyle = createAction('header/updateSocialIconStyle');
export const headerUpdateSocialIsCustom = createAction('header/updateSocialIsCustom');
export const headerUpdateSocialIsActive = createAction('header/updateSocialIsActive');
export const headerUpdateSocialBackgroundColor = createAction('header/updateSocialBackgroundColor');
export const headerUpdateSocialTextColor = createAction('header/updateSocialTextColor');
export const headerUpdateSocialOpacity = createAction('header/updateSocialOpacity');

export const headerUpdateSocialBorder = createAction('header/updateSocialBorder');
export const headerUpdateSocialBorderColor = createAction('header/updateSocialBorderColor');
export const headerUpdateSocialShape = createAction('header/updateSocialShape');

export const headerUpdateExternalUrl = createAction('header/updateExternalUrl');
export const headerUpdateLocation = createAction('header/updateLocation');
export const headerUpdateLocationMap = createAction('header/updateLocationMap');

export const headerUpdateIsActiveButtonCTA = createAction('header/updateIsActiveButtonCTA');
export const headerUpdateIsActiveButtonCart = createAction('header/updateIsActiveButtonCart');
export const headerUpdateIsActiveButtonMessage = createAction('header/updateIsActiveButtonMessage');
export const headerUpdateIsActiveButtonSubscribe = createAction('header/updateIsActiveButtonSubscribe');

export const headerUpdateDirectBackgroundColor = createAction('header/updateDirectBackgroundColor');
export const headerUpdateDirectTextColor = createAction('header/updateDirectTextColor');
export const headerUpdateDirectPosition = createAction('header/updateDirectPosition');
export const headerUpdateDirectText = createAction('header/updateDirectText');
export const headerUpdateDirectIcon = createAction('header/updateDirectIcon');
export const headerUpdateDirectOpacity = createAction('header/updateDirectOpacity');
export const headerUpdateDirectShadow = createAction('header/updateDirectShadow');
export const headerUpdateDirectShadowColor = createAction('header/updateDirectShadowColor');
export const headerUpdateDirectShape = createAction('header/updateDirectShape');
export const headerUpdateDirectBorder = createAction('header/updateDirectBorder');
export const headerUpdateDirectBorderColor = createAction('header/updateDirectBorderColor');

export const headerUpdateCartBackgroundColor = createAction('header/updateCartBackgroundColor');
export const headerUpdateCartTextColor = createAction('header/updateCartTextColor');
export const headerUpdateCartOpacity = createAction('header/updateCartOpacity');

export const headerUpdateSubscribeButtonBackgroundColor = createAction('header/updateSubscribeButtonBackgroundColor');
export const headerUpdateSubscribeButtonTextColor = createAction('header/updateSubscribeButtonTextColor');
export const headerUpdateSubscribeButtonText = createAction('header/updateSubscribeButtonText');
export const headerUpdateSubscribeButtonIcon = createAction('header/updateSubscribeButtonIcon');
export const headerUpdateSubscribeButtonPosition = createAction('header/updateSubscribeButtonPosition');
export const headerUpdateSubscribeButtonOpacity = createAction('header/updateSubscribeButtonOpacity');
export const headerUpdateSubscribeButtonShadow = createAction('header/updateSubscribeButtonShadow');
export const headerUpdateSubscribeButtonShadowColor = createAction('header/updateSubscribeButtonShadowColor');
export const headerUpdateSubscribeButtonShape = createAction('header/updateSubscribeButtonShape');
export const headerUpdateSubscribeButtonBorder = createAction('header/updateSubscribeButtonBorder');
export const headerUpdateSubscribeButtonBorderColor = createAction('header/updateSubscribeButtonBorderColor');

export const headerUpdateButtonsNumber = createAction('header/updateButtonsNumber');

export const headerUpdateSocial = createAction('header/updateSocial');
